import { Router } from '@angular/router';
import { Component, Input, OnInit, OnDestroy, HostListener, ElementRef, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { Connections } from 'src/app/core/interface/auth.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { ProfileService } from 'src/app/core/services/profile.service';
import { environment } from 'src/environments/environment';
import { ErrorMessageComponent } from '../../all-modals/error-message/error-message.component';
import { SuccessMessageComponent } from '../../all-modals/success-message/success-message.component';
import { ConnectionConfirmationModalComponent } from '../connection-confirmation-modal/connection-confirmation-modal.component';
import { ReportConnectionModalComponent } from '../report-connection-modal/report-connection-modal.component';
import { UnsubscribeComponent } from '../../all-modals/unsubscribe/unsubscribe.component';
import { SubscribeComponent } from '../../all-modals/subscribe/subscribe.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-all-connection-modal',
  templateUrl: './all-connection-modal.component.html',
  styleUrls: ['./all-connection-modal.component.scss']
})
export class AllConnectionModalComponent implements OnInit, OnDestroy {

  currentOrientation = 'horizontal';
  tabSeleted: string = 'allconnection';

  connections: any;
  connectionsSaved = [];
  subscriberCount = 0;
  subscribingCount = 0;
  searchText: string = '';
  imagePath: any;
  recent_connections = [];
  userData;
  isLoading: boolean = false;
  subscriberMode = 'free';
  subscriberAll;
  subscribeSubscription: Subscription;
  checkIfMoreData: boolean = false;
  showLoader = false;
  myConnectionPage = 1;
  @Input() subscribe;
  @Input() viewSubscribing;
  @Input() upgradePremiumUserId;
  updatedData: any[];
  updatedDataConnections: any[];
  updatedRecentSavedConnections: any[];

  @ViewChild('connectionsModelDiv', { static: true }) connectionsModelDiv: ElementRef;

  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private _profileService: ProfileService,
    private spinner: NgxSpinnerService,
    private authService: AuthService,
    private _router: Router,
    private elementRef: ElementRef
  ) { }

  ngOnInit() {
    this.userData = this.authService.getCurrentUser();
    this.imagePath = environment.url;

    if (!this.subscribe) {
      this.getConnection(this.myConnectionPage);
    } else {
      this.getSubscribers();
    }
    if (this.viewSubscribing) {
      this.toggleView('recently-added');
    }
  }

  @HostListener('scroll', ['$event'])
  onScroll(event: any) {
    const scrollPosition = (event.target as HTMLElement)
    const atEnd = scrollPosition.scrollHeight - scrollPosition.scrollTop === scrollPosition.clientHeight;
    if(atEnd) {
      if (this.checkIfMoreData) {
        this.showLoader = true;
        this.myConnectionPage = this.myConnectionPage + 1;
        this.getConnection(this.myConnectionPage);
      }
      this.checkIfMoreData = false;
    }
  }

  getConnection(myConnectionPage) {
    if (!this.checkIfMoreData) {
      this.isLoading = true;
    }
    this._profileService.fetchConnectionsPerPage(this.myConnectionPage).subscribe(
      (response: any) => {
        this.isLoading = false;
        if (response.success) {
          this.showLoader = false;
          if (response.meta.pagination.next_page !== null && response.meta.pagination.current_page !== 1) {
            this.checkIfMoreData = true;
            this.updatedDataConnections = [...this.connections, ...response.data.connections];
            this.connections = this.findMutedConnections(this.updatedDataConnections);
            this.updatedRecentSavedConnections = [...this.recent_connections, ...response.data.connections];
            this.recent_connections = this.findMutedConnections(this.updatedRecentSavedConnections);
          } else if(response.meta.pagination.current_page !== 1 && response.meta.pagination.next_page >= 2) {
            this.checkIfMoreData = true;
            this.updatedDataConnections = [...this.connections, ...response.data.connections];
            this.connections = this.findMutedConnections(this.updatedDataConnections);
            this.updatedRecentSavedConnections = [...this.recent_connections, ...response.data.connections];
            this.recent_connections = this.findMutedConnections(this.updatedRecentSavedConnections);
          } else {
            this.checkIfMoreData = true;
            if (response.data.connections && this.connections) {
              this.updatedDataConnections = [...this.connections, ...response.data.connections];
              this.connections = this.findMutedConnections(this.updatedDataConnections);
              this.updatedRecentSavedConnections = [...this.recent_connections, ...response.data.connections];
              this.recent_connections = this.findMutedConnections(this.updatedRecentSavedConnections);
            } else {
              this.connections = this.findMutedConnections(response.data.connections);
              this.connectionsSaved = this.findMutedConnections(response.data.connections);
              this.recent_connections =  this.findMutedConnections(response.data.recent_connections);
            }
          }
          this.showLoader = false;
        }
        if (response.data.dataIsEnded) {
          this.showLoader = false;
          this.checkIfMoreData = false;
        }
      }, (error: any) => {
        this.isLoading = false;
      });
  }

  findMutedConnections(connections){
    const mutedConnections = connections.map((con)=>{
      con.mutedStatus = null;
      if(con.mute_connection_details && con.mute_connection_details.length){
        const mutedUser = con.mute_connection_details.find((item)=>item.performed_by===this.userData.user.id && item.status === 'muted');
        if(mutedUser){
          con.mutedStatus = true;
        }
      }
      return con;
    });
    return mutedConnections;
  }

  getSubscribers(params = '') {
    this.isLoading = true;
    this.subscriberAll = null;
    if (this.subscribeSubscription) {
      this.subscribeSubscription.unsubscribe();
    }
    this.subscribeSubscription = this._profileService.fetchSubscribers(params).subscribe(
      (response: any) => {
        this.isLoading = false;
        if (response.success) {
          if (this.tabSeleted != 'allconnection') {
            this.connections = response.data.subscribers;
          } else {
            if (this.subscriberMode == 'paid') {
              this.connections = response.data.paid_subscribers;
            } else {
              this.connections = response.data.free_subscribers;
            }
          }
          if (this.connections) {
            const user = this.connections.find(element => {
              return this.upgradePremiumUserId == element.user.id
            });
            if (user) {
              user.user['business_pro_plus_user'] = user.is_bpp_user;
              user.user['business_name'] = user['user'].name;
              let obj = {
                sender: {
                  subscriber_id: user.id,
                  status: user.status,
                  paid_subscriber: user.is_paid_subscriber,
                  expired_at: user.expired_at,
                  auto_renew: user.auto_renew,
                }
              }
              user.user['subscriber_request_details'] = obj;
              this.upgradeToPremium(user);
            }
          }
          this.subscriberAll = response.data;

          this.subscriberCount = response.data.subscribers_count;
          this.subscribingCount = response.data.subscribing_count;
        }
      }, (error: any) => {
        this.isLoading = false;
      });
  }
  closeDialog() {
    this.activeModal.dismiss();
  }

  disconnectConnection(user) {
    const modalRef = this.modalService.open(ConnectionConfirmationModalComponent, { centered: true });
    modalRef.componentInstance.isAllModal = true;
    modalRef.componentInstance.userData = { user: user };
    modalRef.result.then(
      (response) => {
        this.ngOnInit();
        this.authService.setProfileCount();
      }, (reason) => {
      });
  }

  blockConnection(userData) {
    userData = {
      user: userData
    }
    const modalRef = this.modalService.open(ConnectionConfirmationModalComponent, { centered: true });
    modalRef.componentInstance.userData = userData;
    modalRef.componentInstance.isBlock = true;
    modalRef.componentInstance.isAllModal = true;
    modalRef.result.then((result) => {
      if (result) {
        this.authService.setProfileCount();
        this.ngOnInit();
      }
    }, (reason) => {
    });
    return;
  }

  reportConnection(userId) {

  }

  muteConnection(userId) {
    const params: Connections = {
      connection: {
        status: 'muted'
      }
    };
    this.isLoading = true;
    this._profileService.muteUnmuteConnection(userId, params).subscribe(
      (response: any) => {
        this.isLoading = false;
        if (response.success) {
          this.authService.setProfileCount();
          const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.CONNECTION_MUTE_SUCCESS;
          this.ngOnInit();
        }
        else if (response.message == "You are not able perform this action!") {
          const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          if (this.authService.isSupplementaryAccount()) {
            modelRef.componentInstance.message = "Oops!, you cannot mute your parent account.";
          } else {
            modelRef.componentInstance.message = "Oops!, you cannot mute your supplementary account.";
          }
          modelRef.componentInstance.title = "Alert!";
        }


      }, (error: any) => {
        this.isLoading = false;
        // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
        this.ngOnInit();
      });
  }

  unMuteConnection(userId) {
    const params: Connections = {
      connection: {
        status: 'unmute'
      }
    };
    this.isLoading = true;
    this._profileService.muteUnmuteConnection(userId, params).subscribe(
      (response: any) => {
        this.isLoading = false;
        this.authService.setProfileCount();
        const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
        modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.CONNECTION_UNMUTE_SUCCESS;
        this.ngOnInit();

      }, (error: any) => {
        this.isLoading = false;
        // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
        this.ngOnInit();
      });
  }

  toggleView(tab: string) {
    this.tabSeleted = tab;
    if (this.subscribe) {
      this.updateConnection();
    } else {
      if (tab == 'recently-added') {
        this.connections = this.recent_connections;
      } else {
        this.connections = this.connectionsSaved;
      }
    }
  }

  toggleSubscriberView(tab) {
    this.subscriberMode = tab;
    if (!this.subscriberAll)
      return
    if (tab == 'free') {
      this.connections = this.subscriberAll.free_subscribers;
    } else {
      this.connections = this.subscriberAll.paid_subscribers;
    }
  }
  updateConnection() {
    if (this.tabSeleted == 'allconnection') {
      this.getSubscribers();
    } else {
      this.getSubscribers('?status=subscribed&request_sent_to_me=1');
    }
  }

  unsubscribe(user) {
    user.user['business_pro_plus_user'] = user.is_bpp_user;
    user.user['business_name'] = user['user'].name;
    let obj = {
      sender: {
        subscriber_id: user.id,
        status: user.status,
        paid_subscriber: user.is_paid_subscriber,
        expired_at: user.expired_at,
        auto_renew: user.auto_renew,
      }
    }
    user.user['subscriber_request_details'] = obj;
    if (user && user.user && (user.user.business_pro_plus_user || user.is_paid_subscriber) && (!this.userData.user.subscription.plan.can_bulk_consume || user.is_paid_subscriber) && !this.authService.isSupplementaryAccount()) {
      const modalRef = this.modalService.open(UnsubscribeComponent, { centered: true, backdrop: 'static', keyboard: false });
      modalRef.componentInstance.currentuser = user.user;
      modalRef.result.then((result) => {
        if (result == 'success') {
          if (!user.is_paid_subscriber) {
            this.subscribingCount = this.subscribingCount - 1;
            this.authService.setProfileCount();
            this.connections = this.connections.filter((ele) => {
              return ele.id != user.id
            });
          } else {
            user.auto_renew = !user.auto_renew;
          }
        } else if (result == 'upgrade') {
          this.upgradeToPremium(user);
        }
      });
      return;
    }
    const modalRef = this.modalService.open(ConnectionConfirmationModalComponent, { centered: true });
    modalRef.componentInstance.userData = { user: user };
    modalRef.componentInstance.return = true;
    modalRef.componentInstance.isAllModal = true;
    modalRef.componentInstance.title = "Unsubscribe";
    modalRef.componentInstance.message = "Are you sure you want to unsubscribe " + user.user.name + "?";
    modalRef.componentInstance.successBtn = "Unsubscribe";
    modalRef.result.then((result) => {
      if (result == 'success') {
        this.isLoading = true;
        this._profileService.profileUnsubscribe('unsubscribed', user.id).subscribe((response) => {
          this.isLoading = false;
          if (response.success) {
            this.subscribingCount = this.subscribingCount - 1;
            this.authService.setProfileCount();
            const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
            modalRef.componentInstance.message = "You have successfully unsubscribed " + user.user.name;
            this.connections = this.connections.filter((ele) => {
              return ele.id != user.id
            });
          }
          else if (!response.success) {
            const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
            modalRef.componentInstance.message = "Error occured unsubscribing " + user.user.name + ".";
          }
        });
      }
    });
  }

  upgradeToPremium(user) {
    this.upgradePremiumUserId = 0;
    const modalRef = this.modalService.open(SubscribeComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.currentuser = user.user;
    modalRef.componentInstance.upgrade = true;
    modalRef.result.then((result) => {
      if (result) {
        user.auto_renew = result.auto_renew;
        user.expired_at = result.expired_at;
        user.status = result.status;
        if (result.paid_subscriber) {
          user.is_paid_subscriber = result.paid_subscriber;
        }
      }
    });
  }
  removeConnection(user) {
    const modalRef = this.modalService.open(ConnectionConfirmationModalComponent, { centered: true });
    modalRef.componentInstance.userData = { user: user };
    modalRef.componentInstance.return = true;
    modalRef.componentInstance.isAllModal = true;
    modalRef.componentInstance.title = "Remove subscriber?";
    modalRef.componentInstance.message = "ScriptDoor won't tell " + user.user.name + " they were removed from your subscribers.";
    modalRef.componentInstance.successBtn = "Remove";
    modalRef.result.then((result) => {
      if (result == 'success') {
        this.isLoading = true;
        this._profileService.profileUnsubscribe('unsubscribed', user.id).subscribe((response) => {
          this.isLoading = false;
          if (response.success) {
            this.authService.setProfileCount();
            const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
            modalRef.componentInstance.message = user.user.name + " has been successfully removed from your subscribers.";
            this.connections = this.connections.filter((ele) => {
              return ele.id != user.id
            });
            this.subscriberCount = this.subscriberCount - 1;
            if (this.subscriberAll && this.subscriberAll.free_subscribers) {
              this.subscriberAll.free_subscribers = this.subscriberAll.free_subscribers.filter((ele) => {
                return ele.id != user.id
              });
            }
          }
          else if (!response.success) {
            const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
            modalRef.componentInstance.message = "Error occured removing " + user.user.name + ".";
          }
        });
      }
    });
  }

  openReportConnectionModal(connectionObj) {

    const connection = {
      id: connectionObj.id,
      user: connectionObj,
      otherId: connectionObj.user.id
    };

    const modalRef = this.modalService.open(ReportConnectionModalComponent, { centered: true });
    modalRef.componentInstance.connection = connection;
  }

  redirectToUser(userId) {
    this.modalService.dismissAll();
    this._router.navigate(['/other-profile', userId]);
  }

  ngOnDestroy() {
    if (this.subscribeSubscription) {
      this.subscribeSubscription.unsubscribe();
    }
  }
}
